import { createSelector } from 'reselect';

const selectDbnpMappings = (state: any) => state.dbnpMappings;


export const selectDbnpMappingCurrentItem = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.current);

export const selectDbnpMappingListItems = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.list);

export const selectDbnpMappingItemById = (itemId: any) =>
    createSelector(selectDbnpMappingListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbnpMappingQueryItems = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.query);

export const selectDbnpMappingCreatedItem = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.create);

export const selectDbnpMappingUpdatedItem = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.update);

export const selectDbnpMappingReadItem = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.read);

export const selectDbnpMappingDeletedItem = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.delete);

export const selectDbnpMappingSearchedItems = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.search);

export const selectDbnpMappingItemsCount = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.count);

export const selectDbnpMappingItemsFilter = createSelector([selectDbnpMappings], (dbnpMappings) => dbnpMappings.filter);